import {Injectable} from '@angular/core';
import {MenuItem} from 'primeng/api';

@Injectable({
    providedIn: 'root'
})
export class OrdersDataService {

    public items: MenuItem[] = [];
    public home: MenuItem = {icon: 'pi pi-home', routerLink: '/'};

    constructor() {
    }

    public reset(): void {
        this.items = [];
    }

    public addItemToBreadcrumbItems(item: MenuItem): void {
        let existing: MenuItem[] = (this.items || []).filter((f: MenuItem): boolean => f.label === item.label);
        if (!existing || existing.length === 0) {
            this.items.push(item);
        } else {
            existing[0].routerLink = item.routerLink;
            this.items.splice((this.items.indexOf(existing[0]) + 1), this.items.length);
        }
    }

    public onBreadcrumbItemClick(event$: any): void {
        this.items.splice(this.items.indexOf(event$.item) + 1);
    }
}
